import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { getServices, getServiceAttendance } from '../../services/api';
import { FiUserCheck, FiUserX } from 'react-icons/fi';
import PhoneLink from '../../components/PhoneLink';

const AbsenteeReport = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(searchParams.get('service') || '');
  const [detail, setDetail] = useState(null); // { service, attended, absent }
  const [view, setView] = useState('absent'); // 'attended' | 'absent'

  useEffect(() => {
    getServices({ from: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10) })
      .then(r => setServices(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedService) { setDetail(null); return; }
    getServiceAttendance(selectedService).then(r => setDetail(r.data || null)).catch(() => setDetail(null));
  }, [selectedService]);

  const selectedSvc = services.find(s => s.id == selectedService) || detail?.service;
  const fullName = (m) => [m.first_name, m.middle_name, m.last_name].filter(Boolean).join(' ');
  const list = detail ? (view === 'attended' ? detail.attended : detail.absent) : [];

  return (
    <div className="page-content">
      <div className="page-header">
        <div><h1>{t('nav.attendanceReport')}</h1></div>
      </div>

      <div className="filters-row">
        <label style={{ fontSize: 13, fontWeight: 600 }}>Select Service:</label>
        <select className="filter-select" value={selectedService} onChange={e => setSelectedService(e.target.value)} style={{ minWidth: 280 }}>
          <option value="">— Choose a service —</option>
          {services.map(s => (
            <option key={s.id} value={s.id}>{s.date} — {s.name} ({s.actual_count} attended)</option>
          ))}
        </select>
      </div>

      {selectedService && detail && (
        <>
          <div className="stat-cards" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', marginBottom: 20 }}>
            <div className="stat-card" onClick={() => setView('attended')} style={{ cursor: 'pointer', border: `2px solid ${view === 'attended' ? '#16a34a' : 'var(--border)'}` }}>
              <div className="stat-icon" style={{ background: '#dcfce7', color: '#16a34a', fontSize: 22 }}><FiUserCheck /></div>
              <div><div className="stat-label">Attended</div><div className="stat-value">{detail.attended.length}</div></div>
            </div>
            <div className="stat-card" onClick={() => setView('absent')} style={{ cursor: 'pointer', border: `2px solid ${view === 'absent' ? '#dc2626' : 'var(--border)'}` }}>
              <div className="stat-icon" style={{ background: '#fee2e2', color: '#dc2626', fontSize: 22 }}><FiUserX /></div>
              <div><div className="stat-label">Absent</div><div className="stat-value">{detail.absent.length}</div></div>
            </div>
          </div>

          <div className="table-card">
            <div style={{ padding: '12px 18px', background: view === 'attended' ? '#dcfce7' : '#fef9c3', borderBottom: '1px solid #e5e7eb', fontSize: 13, fontWeight: 600, color: view === 'attended' ? '#15803d' : '#a16207' }}>
              {view === 'attended' ? 'Attended' : 'Absent from'}: {selectedSvc?.name} on {selectedSvc?.date}
            </div>
            <table>
              <thead><tr><th>#</th><th>{t('common.name')}</th><th>Card</th><th>{t('common.phone')}</th><th>{t('members.spiritualFather')}</th></tr></thead>
              <tbody>
                {list.length === 0 ? (
                  <tr><td colSpan={5}><div className="empty-state"><p>{view === 'attended' ? 'No one recorded as attended' : 'All members attended!'}</p></div></td></tr>
                ) : list.map((m, i) => (
                  <tr key={m.id}>
                    <td data-label="#">{i + 1}</td>
                    <td data-label={t('common.name')}><strong>{fullName(m)}</strong></td>
                    <td data-label="Card" style={{ fontFamily: 'monospace', fontSize: 12, color: '#6b7280' }}>{m.card_number || '—'}</td>
                    <td data-label={t('common.phone')}><PhoneLink phone={m.phone} whatsapp={m.whatsapp} /></td>
                    <td data-label={t('members.spiritualFather')}>{(m.father_name || '').trim() || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AbsenteeReport;
